import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";
import { v4 as uuidv4 } from "uuid";
import { getCallerUrl, getCookieValue } from "../Utils/utils";


const baseUrl = process.env.REACT_APP_BASE_URL;

export const getJWTToken = createAsyncThunk(
    "finalStatus/getJWTToken",
    async ({ token, surcharge = {} }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `${baseUrl}/checkout/sessions/${token}/gpay/details`, surcharge
            );
            return response.data;
        } catch (err) {
            return rejectWithValue(err?.response?.data || err.message);
        }
    }
);

export const initiateGooglePayPayment = createAsyncThunk(
    "paymentInitiation/initiateGooglePayPayment",
    async ({ token, payload }, { rejectWithValue }) => {
        try {
            const headers = {
                "X-Request-Id": uuidv4(),
                "X-Caller-Url": getCallerUrl(),
            };
            const sessionToken = getCookieValue('shopper_token') || localStorage.getItem("sessionToken");
            if (sessionToken) {
                headers.Authorization = `Session ${sessionToken}`;
            }

            const response = await axiosInstance.post(
                `${baseUrl}/checkout/sessions/${token}`,
                payload,
                { headers }
            );

            if (
                response.data?.status?.status === "Rejected" ||
                response.data?.status?.status === "Failed"
            ) {
                return rejectWithValue(response?.data);
            }

            return response.data;
        } catch (error) {
            return rejectWithValue(getErrorMessage(error.response));
        }
    }
);

const initialState = {
    isGpayDetailsLoading: true,
    JWT: null,
    isGooglePayAvailable: true,
    isApplePayAvailable: true
};

const extractStatusReason = (statusReason) => {
    if (statusReason && statusReason.includes(":")) {
        return statusReason.split(":").slice(1).join(":").trim();
    }
    return statusReason;
};

export const gpayDetailsSlice = createSlice({
    name: "finalStatus",
    initialState,
    reducers: {
        setIsGooglePayAvailable: (state, action) => {
            state.isGooglePayAvailable = action.payload
        },
        setIsApplePayAvailable: (state, action) => {
            state.isApplePayAvailable = action.payload
        },
        resetGpayResponse: (state) => {
            state.JWT = "";
            state.isActiveLoading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getJWTToken.pending, (state) => {
                state.isGpayDetailsLoading = true;
            })
            .addCase(getJWTToken.fulfilled, (state, action) => {
                state.isGpayDetailsLoading = false;
                state.JWT = action.payload?.token;
                state.isGooglePayAvailable = true

            })
            .addCase(getJWTToken.rejected, (state, action) => {
                state.isGpayDetailsLoading = false;
                state.JWT = action.payload?.token;
                state.isGooglePayAvailable = false
            });
    },
});

export const { resetGpayResponse, setIsGooglePayAvailable, setIsApplePayAvailable } = gpayDetailsSlice.actions;
export default gpayDetailsSlice.reducer;


